import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useLanguage } from '../LanguageContext';
import { Link as RouterLink, useLocation } from 'react-router-dom';

// NEUE IMPORTE FÜR DAS MOBILE MENÜ
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

const Header = () => {
    const { language, setLanguage, t } = useLanguage();
    const location = useLocation();

    // Hooks, um die Bildschirmgröße zu erkennen
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // State für das mobile Menü (Drawer)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleLanguageChange = (event) => {
        setLanguage(event.target.value);
    };

    const handleMobileMenuToggle = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    // Die Links für das mobile Menü
    const menuLinks = [
        { text: t('header_signUp'), path: '/' },
        { text: t('header_feedback'), path: '/feedback' },
    ];

    // Inhalt des ausfahrbaren mobilen Menüs
    const drawerContent = (
        <Box
            sx={{ width: 250, pt: 2 }}
            role="presentation"
            onClick={handleMobileMenuToggle}
            onKeyDown={handleMobileMenuToggle}
        >
            <List>
                {menuLinks.map((link) => (
                    <ListItem key={link.text} disablePadding>
                        <ListItemButton component={RouterLink} to={link.path} selected={location.pathname === link.path}>
                            <ListItemText primary={link.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider sx={{ my: 1 }} />

        </Box>
    );

    return (
        <AppBar
            position="static"
            elevation={2}
            sx={{ backgroundColor: 'white', color: 'black' }}
        >
            <Toolbar>
                <a href="/">


                <img
                    src="/img/carrera-logo.png"
                    alt="Carrera Logo"
                    style={{ height: '40px', marginRight: '16px', marginTop:2 }}
                />
                </a>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
                    Beta
                </Typography>

                {isMobile ? (
                    // MOBILE ANSICHT: Burger-Icon
                    <>
                        <IconButton
                            color="inherit"
                            aria-label="open menu"
                            edge="end"
                            onClick={handleMobileMenuToggle}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Drawer
                            anchor="right"
                            open={mobileMenuOpen}
                            onClose={handleMobileMenuToggle}
                        >
                            {drawerContent}
                        </Drawer>
                    </>
                ) : (
                    // DESKTOP ANSICHT: Volle Navigationsleiste
                    <>
                        <Box>
                            <Button
                                color="primary"
                                variant={location.pathname === '/' ? 'contained' : 'text'}
                                component={RouterLink}
                                to="/"
                                sx={{ marginRight: 1 }}
                            >
                                {t('header_signUp')}
                            </Button>
                            <Button
                                color="primary"
                                variant={location.pathname === '/feedback' ? 'contained' : 'text'}
                                component={RouterLink}
                                to="/feedback"
                            >
                                {t('header_feedback')}
                            </Button>
                        </Box>


                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Header;